import React, { Fragment, useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

//Components
import Landing from './components/loggedOut/Landing';
import AboutUs from './components/loggedOut/AboutUs';
import ContactUs from './components/loggedOut/ContactUs';

import DirectDB from './components/admin/DirectDB';
import WorkerList from './components/admin/WorkerList';
import ShiftListAll from './components/admin/ShiftListAll';
import ClientList from './components/admin/ClientList';
import ExpenseList from './components/admin/ExpenseList';
import ServerLog from './components/admin/ServerLog';
import DatabaseReset from './components/admin/DatabaseReset';

import InputShift from './components/InputShift';
import ListShifts from './components/ListShifts';
import SignIn from './components/SIgnIn';
import Navbar from './components/Navbar';
import MyBMenu from './components/MyBMenu';

import CommunityOutdoorAccess from './components/loggedOut/ourServicesPages/CommunityOutdoorAccess'
import InHomeSupport from './components/loggedOut/ourServicesPages/InHomeSupport'
import Respite from './components/loggedOut/ourServicesPages/Respite'
import AccessibleEats from './components/loggedOut/ourServicesPages/AccessibleEats'
import TuesdaySocial from './components/loggedOut/ourServicesPages/TuesdaySocial'
import NeuroPathways from './components/loggedOut/ourServicesPages/NeuroPathways'
import Crafternoon from './components/loggedOut/ourServicesPages/Crafternoon'
import TacticalMinds from './components/loggedOut/ourServicesPages/TacticalMinds'
import OurServices from './components/loggedOut/ourServicesPages/OurServices';
import Footer from './components/loggedOut/Footer';

const ALASKA_IMAGE = "/alaska.png";
const ADELAIDE_TIME_ZONE = "Australia/Adelaide";

const isAprilFoolsInAdelaide = () => {
  const parts = new Intl.DateTimeFormat("en-AU", {
    timeZone: ADELAIDE_TIME_ZONE,
    month: "numeric",
    day: "numeric",
  }).formatToParts(new Date());
  const month = Number(parts.find((part) => part.type === "month")?.value);
  const day = Number(parts.find((part) => part.type === "day")?.value);
  return month === 4 && day === 1;
};

const swapToAlaska = (target) => {
  if (!target) return;
  if (target.closest?.('[data-no-alaska="true"]')) return;
  if (target.tagName === "IMG") {
    target.src = ALASKA_IMAGE;
  }

  if (target.style?.backgroundImage && target.style.backgroundImage.includes("/marketing_images/")) {
    target.style.backgroundImage = `url('${ALASKA_IMAGE}')`;
  }
};

function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(0);

  const setAuth = (boolean) => {
    setIsAuthenticated(boolean);
  }
  const setAdm = (three_val) => {
    setIsAdmin(three_val);
  }

  async function isAuth() {
    try {
      const response = await fetch("/auth/is-verify", {
        method: "GET",
        headers: { token: localStorage.token }
      })

      const parseRes = await response.json();
      if (parseRes.valid === true) {
        setIsAuthenticated(true);
        if (parseRes.admin === 1) {
          setIsAdmin(1);
        } else if (parseRes.admin === 2) {
          setIsAdmin(2);
        }

      } else {
        setIsAuthenticated(false);
        setIsAdmin(0);

      }

    } catch (err) {
      console.error("Cannot check if authenticated")
      console.error(err.message);
    }
  }

  useEffect(() => {
    isAuth();
  }, [])

  useEffect(() => {
    if (!isAprilFoolsInAdelaide()) return;

    const forceAlaska = () => {
      document.querySelectorAll("img:not([data-no-alaska='true'])").forEach((img) => swapToAlaska(img));
      document.querySelectorAll('[style*="/marketing_images/"]').forEach((node) => swapToAlaska(node));
    };

    forceAlaska();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          swapToAlaska(node);
          if (node.querySelectorAll) {
            node.querySelectorAll("img:not([data-no-alaska='true'])").forEach((img) => swapToAlaska(img));
            node.querySelectorAll('[style*="/marketing_images/"]').forEach((el) => swapToAlaska(el));
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    // <Fragment>
    //   <div className="container">
    //     <InputShift />
    //     <ListShifts />
    //   </div>
    // </Fragment>
    <Fragment>
      <Router>
        {/* <Navbar signedIn={signedIn} setSignedIn={setSignedIn} /> */}
        <MyBMenu setAuth={setAuth} setAmd={setAdm} authenticationStatus={isAuthenticated} adminStatus={isAdmin} />
        <Navbar setAuth={setAuth} setAmd={setAdm} authenticationStatus={isAuthenticated} adminStatus={isAdmin}></Navbar>
        <Routes>
          <Route exact path='/' element={<Landing />} />
          <Route exact path='/AboutUs' element={<AboutUs />} />
          <Route exact path='/ContactUs' element={<ContactUs />} />
          <Route path="/OurServices">
            <Route path="" element={<OurServices />} />
            <Route path="CommunityOutdoorAccess" element={<CommunityOutdoorAccess />} />
            <Route path="InHomeSupport" element={<InHomeSupport />} />
            <Route path="Respite" element={<Respite />} />
            <Route path="AccessibleEats" element={<AccessibleEats />} />
            <Route path="TuesdaySocial" element={<TuesdaySocial />} />
            <Route path="NeuroPathways" element={<NeuroPathways />} />
            <Route path="Crafternoon" element={<Crafternoon />} />
            <Route path="TacticalMinds" element={<TacticalMinds />} />
          </Route>


          <Route exact path='/InputShift' element={isAuthenticated && isAdmin === 0 ? <InputShift /> : isAuthenticated && isAdmin !== 0 ? <Navigate to="/" /> : <Navigate to="/SignIn" />} />
          <Route exact path='/ListShifts' element={isAuthenticated && isAdmin === 0 ? <ListShifts /> : isAuthenticated && isAdmin !== 0 ? <Navigate to="/" /> : <Navigate to="/SignIn" />} />

          <Route exact path='/DirectDB' element={isAuthenticated && isAdmin >= 1 ? <DirectDB is_admin={isAdmin} /> : <Navigate to="/SignIn" />} />
          <Route exact path='/WorkerList' element={isAuthenticated && isAdmin >= 1 ? <WorkerList is_admin={isAdmin} /> : <Navigate to="/SignIn" />} />
          <Route exact path='/ShiftListAll' element={isAuthenticated && isAdmin >= 1 ? <ShiftListAll is_admin={isAdmin} /> : <Navigate to="/SignIn" />} />
          <Route exact path='/ClientList' element={isAuthenticated && isAdmin >= 1 ? <ClientList is_admin={isAdmin} /> : <Navigate to="/SignIn" />} />
          <Route exact path='/ExpenseList' element={isAuthenticated && isAdmin >= 1 ? <ExpenseList is_admin={isAdmin} /> : <Navigate to="/SignIn" />} />


          <Route exact path='/DatabaseReset' element={isAuthenticated && isAdmin === 2 ? <DatabaseReset is_admin={isAdmin} /> : <Navigate to="/SignIn" />} />
          <Route exact path='/ServerLog/:date' element={isAuthenticated && isAdmin === 2 ? <ServerLog /> : <Navigate to="/SignIn" />} />


          {/* <Route exact path='/SignIn' render={props => !isAuthenticated ? <SignIn {...props} /> : <Navigate to="/" />} /> */}
          <Route exact path='/SignIn' element={!isAuthenticated ? <SignIn setAuth={setAuth} setAdm={setAdm} /> : <Navigate to="/ListShifts" />} />
        </Routes>
        {/* CTA / Contact */}
        {!isAuthenticated && <Footer />}
      </Router>
    </Fragment>
  );
}

export default App;
